import React from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.5rem;
`;

const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ProducersSelect = ({
  producers = [],
  selectedProducers = [],
  onChange,
  error,
}) => {
  const handleProducerChange = (producerId, isChecked) => {
    let newSelected;
    if (isChecked) {
      newSelected = [...selectedProducers, producerId];
    } else {
      newSelected = selectedProducers.filter((id) => id !== producerId);
    }
    onChange(newSelected);
  };

  return (
    <Form.Group>
      <Form.Label>Producenci *</Form.Label>
      <CheckboxContainer>
        {producers.length === 0 ? (
          <div className="text-muted">Brak dostępnych producentów</div>
        ) : (
          producers.map((producer) => (
            <CheckboxItem key={producer._id}>
              <Form.Check
                type="checkbox"
                id={`producer-${producer._id}`}
                label={producer.name}
                checked={selectedProducers.includes(producer._id)}
                onChange={(e) =>
                  handleProducerChange(producer._id, e.target.checked)
                }
              />
            </CheckboxItem>
          ))
        )}
      </CheckboxContainer>
      {error && <Form.Text className="text-danger">{error}</Form.Text>}
    </Form.Group>
  );
};

export default ProducersSelect;
